import styled from "styled-components";

export const LogoImg = styled.img`
    width: 12.5rem;
    height: 4rem;
    margin-left: 1.4rem;
    margin-top: 2rem;
`;
